<!--exchange connector/rules popup-->
<popup-c class="no-content-padding bs-enabled" size="large"
	   head="Create <b>Trustifi Junk Rule</b> in Exchange"
	   subTitle="This will add a mail-flow rule that moves messages flagged by Trustifi to the recipient’s Junk folder."
	   (closeCb)="closePopup();">
	<div class="flex-column overflow-auto f-1-0 pt-2 gap-2" style="padding: 20px;">
		<!--steps progress-->
		<div class="steps-container" style="font-size: 0.8rem;">
			<div class="step-tab"
				 *ngFor="let stepKey of validSteps | keyvalue: gs.returnZero"
				 [ngClass]="{'active' : step === stepKey.value}">
				{{stepKey.value}}
			</div>
		</div>

		<!--Steps content:-->
		<!--STEP: General instructions-->
		<div class="flex-column overflow-auto animated fadeIn f-1-0 gap-3 p-2 pt-3" *ngIf="step === dic.CONSTANTS.exchangeRulesSteps.generalInformation" style="line-height: 2;">
	  		<span style="position: relative; padding-left: 15px;" class="diamond-indent">By clicking "Configure" below, Trustifi will create a mail flow rule in Microsoft Exchange named <b>"Trustifi Junk Rule"</b>.</span>

			<span style="position: relative; padding-left: 15px;" class="diamond-indent">
				The rule conditions will be set to match on messages that:
				<ul class="mb-0 ps-3">
					<li>
						Arrive from Trustifi's inbound IPs: <br/>
						<div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 0.5rem 0.75rem; padding: 0.75rem 0.85rem; border: 1px solid #e2e8f0; background: #f8fafc; border-radius: 8px; max-width: 520px; margin-top: 0.4rem;">
							<span *ngFor="let ip of ipAddresses" style="display: inline-flex; align-items: center; justify-content: center; padding: 0.35rem 0.55rem; border-radius: 999px; background: white; border: 1px solid #dfe7ef; font-family: 'Roboto Mono', monospace; font-size: 12px; color: #1f2d3d;">
								{{ip}}
							</span>
						</div>
					</li>
			  	<li> Contain the header <code>x-trustifi-junk</code> with a value of <code>yes</code></li>
				</ul>
				 When matched, the rule will set the message <b>Spam Confidence Level (SCL)</b> to <b>7</b>, so the message is delivered to the recipient's Junk folder.
	  		</span>

			<span style="position: relative; padding-left: 15px;" class="diamond-indent">The rule will be created <b>enabled</b> by default, so Junk-folder handling becomes active immediately, no further action is required in Exchange.</span>

			<div class="flex-row gap-2 align-items-baseline">
				<i class="far fa-exclamation-triangle opacity-25"></i>
				<span class="fw-bold">Before taking the next step:</span>
			</div>

			<div class="bg-light p-2">
				<ul style="list-style-type: number; margin-bottom: 0;">
					<li>Make sure your PowerShell integration with Trustifi is active and valid.</li>
					<li>Make sure remote PowerShell access is enabled in your Exchange tenant.</li>
				</ul>
			</div>
		</div>

		<!--STEP: Summary-->
		<div class="flxClmn f-1-0 animated fadeIn gap-3 p-2 pt-3" *ngIf="step === dic.CONSTANTS.exchangeRulesSteps.summary">
			<span>The <b>Trustifi Junk Rule</b> is being created in Microsoft Exchange.
				<br/><br/>
				<span style="font-size: 13px;"><u>Note</u>: This process may take a couple of minutes.</span>
			</span>
			<div class="border w-100 p-4 flex-column gap-3" style="max-width: 520px; background: white;"
				 [ngClass]="{'text-danger border-danger' : ruleStatus.status === 'failure', 'text-success border-success' : ruleStatus.status === 'success', 'text-warning border-warning' : ruleStatus.status === 'info'}"
				 *ngIf="ruleStatus && ruleStatus.status">
                        <span class="fw-bold">
                            {{ruleStatus.status === 'failure' ? 'Configuration process failed' :
							ruleStatus.status === 'success' ? 'Configuration process finished successfully' :
							ruleStatus.status === 'info' ? 'Trustifi Junk Rule already exists.' : 'Looks like the configuration process hasn\'t finished yet.'}}
                        </span>
				<span *ngIf="ruleStatus.message && ruleStatus.status !== 'info'">{{ruleStatus.message}}</span>
			</div>

			<div class="flxClmn centralize" style="flex: 1 0;" *ngIf="junkRuleInProcess">
				<loader height="100" width="100" style="opacity: 0.8;"></loader>
				<span class="text-primary mt-1 fw-500">Creating Trustifi Junk Rule</span>
				<span class="text-primary">Please wait. Process may take a while...</span>
			</div>
		</div>

		<!--error message and buttons-->
		<div class="flex-row justify-content-between align-items-end mb-3 px-4 w-100">
			<span class="f-1-0 pe-3 text-danger" style="min-height: 40px;">{{errorMsg || ' '}}</span>

			<div class="flex-row gap-3" style="font-size: 13px;">
				<btn-c class="popup-action-btn"
					 *ngIf="step === dic.CONSTANTS.exchangeRulesSteps.generalInformation"
					 variant="outlined"
					 (action)="closePopup();">
					Cancel
				</btn-c>
				<btn-c class="popup-action-btn"
					 *ngIf="step !== dic.CONSTANTS.exchangeRulesSteps.generalInformation"
					 variant="outlined"
					 (action)="backStep();">
					Back
				</btn-c>
				<btn-c class="popup-action-btn"
					 *ngIf="step === dic.CONSTANTS.exchangeRulesSteps.generalInformation"
					 (action)="nextStep();">
					Configure
				</btn-c>
				<btn-c class="popup-action-btn"
					   *ngIf="step === dic.CONSTANTS.exchangeRulesSteps.summary"
					   [isDisabled]="junkRuleInProcess"
					   (action)="closePopup();">
					OK
				</btn-c>
			</div>
		</div>
	</div>
</popup-c>
